import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import formatCurrency from "../../unit/formatCurrency";
interface RecordType {
  signup_time: any;
  verify_time: any;
  lastcheckmessage: any;
  calculated_time: any;
  last_login_time: "";
  applications?: {};
  paymentAccountData?: {};
  plaidAccountList?: {};
  plaidAccountList?: {};
  adviceRequest?: {};
  plaidAccount?: {
    income_level: any;
    income_stability: any;
    spending_mix?: any;
    spending_within_means?: any;
    spending_stability?: any;
    savings_net_asset_mdb?: any;
    savings_net_asset_nsf?: any;
    savings_net_credit_mdb?: any;
    savings_net_safety?: any;
    financial_iq?: any;
    total_score?: any;
  };
}
import formatDate from "../../unit/formatDate";
import CustomTable from "../../unit/CustomTable";
import React from "react";
import CustomSummaryApplicationList from "./CustomSummaryApplicationList";
import CustomSummaryAccountList from "./CustomSummaryAccountList";
import CustomSummaryPaymentAccountList from "./CustomSummaryPaymentAccountList";
import Button from "@mui/material/Button";
import CustomTabButton from "../../unit/CustomTabButton";
import CustomSummaryAccountBalanceList from "./CustomSummaryAccountBalanceList";
import CustomSummaryHmScoreList from "./CustomSummaryHmScoreList";
import CustomSummaryCashFlow from "./CustomSummaryCashFlow";
import CustomDetailBox from "./CustomDetailBox";
const TableCellRight = styled(TableCell)({ textAlign: "right" });
interface RecordType {
  signup_time: any;
  verify_time: any;
  lastcheckmessage: any;
  calculated_time: any;
  last_login_time: "";
  applications?: {};
  paymentAccountData?: {};
  plaidAccountList?: {};
  hmScoreHistory?: {};
  adviceRequest?: {};
  plaidAccount?: {
    income_level: any;
    income_stability: any;
    spending_mix?: any;
    spending_within_means?: any;
    spending_stability?: any;
    savings_net_asset_mdb?: any;
    savings_net_asset_nsf?: any;
    savings_net_credit_mdb?: any;
    savings_net_safety?: any;
    financial_iq?: any;
    total_score?: any;
  };
}
const FieldShow = ({ ...props }) => {
  const title = props.title;
  const value = props.value;
  const disabled = props.disabled;
  let textcolor = "textSecondary";
  if (disabled == "Yes") {
    textcolor = "#d5d5d5";
  } else {
    textcolor = "textSecondary";
  }
  return (
    <Typography variant="body2" color={textcolor} sx={{ mb: 1 }}>
      <b>{title + ` : `} </b>
      {value}
    </Typography>
  );
};

const CustomSummaryFinancialTabList = ({ ...props }) => {
  const userId = props.userId;
  let record: RecordType = props.record;
  const [activeTab, setActiveTab] = React.useState(1);
  record = props.record;

  let plaidAccount: RecordType["plaidAccount"] =
    record && record.plaidAccount ? record.plaidAccount : undefined;
  let hmScoreHistory: RecordType["hmScoreHistory"] =
    record && record.hmScoreHistory ? record.hmScoreHistory : undefined;
  let paymentAccountData: RecordType["paymentAccountData"] =
    record && record.paymentAccountData ? record.paymentAccountData : undefined;
  let plaidAccountList: RecordType["plaidAccountList"] =
    record && record.plaidAccountList ? record.plaidAccountList : undefined;
  let adviceRequest: RecordType["adviceRequest"] =
    record && record.adviceRequest ? record.adviceRequest : undefined;

  const handleChange = (newValue: number) => {
    setActiveTab(newValue);
  };
  return (
    <Box sx={{ width: "100%", pt: 0, height: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <CustomTabButton
          variant="text"
          onClick={() => handleChange(1)}
          className={activeTab === 1 ? "Mui-selected" : ""}
          id="btn-show-tab-hmscore"
        >
          HM Score
        </CustomTabButton>
        <CustomTabButton
          variant="text"
          onClick={() => handleChange(2)}
          className={activeTab === 2 ? "Mui-selected" : ""}
          id="btn-show-tab-balancesheet"
        >
          Balance Sheet
        </CustomTabButton>
        <CustomTabButton
          variant="text"
          onClick={() => handleChange(3)}
          className={activeTab === 3 ? "Mui-selected" : ""}
          id="btn-show-tab-cashflows"
        >
          Cash Flows
        </CustomTabButton>
      </Box>
      <CustomDetailBox sx={{ display: activeTab === 1 ? "block" : "none" }}>
        <div id="sectionTwo" style={{ width: "100%" }}>
          <CustomSummaryHmScoreList userId={userId} data={hmScoreHistory} />
        </div>
      </CustomDetailBox>
      <CustomDetailBox sx={{ display: activeTab === 2 ? "block" : "none" }}>
        {/* <CustomSummaryAccountBalanceList userId={userId} record={record} /> */}
        Coming soon
      </CustomDetailBox>
      <CustomDetailBox sx={{ display: activeTab === 3 ? "block" : "none" }}>
        <CustomSummaryCashFlow userId={userId} />
      </CustomDetailBox>
    </Box>
  );
};

export default CustomSummaryFinancialTabList;
